import { Gear, Blinker, DriveMode } from './drive';
import { MediaDevice, CameraDevice, MicrophoneDevice } from './mediaDevice';

export namespace Vehicle {
    export type Id = string

    export namespace PredefinedCameraPosition {
        export const Front = 'BOTTOM_CENTER' as MediaDevice.Tag;
        export const Back = 'UPPER_CENTER' as MediaDevice.Tag;
        export const Left = 'BOTTOM_LEFT' as MediaDevice.Tag;
        export const Right = 'BOTTOM_RIGHT' as MediaDevice.Tag;
        export const Interior = 'UPPER_RIGHT' as MediaDevice.Tag;
    }

    export interface Status {
        currentSpeed: number;
        targetSpeed: number;
        stateMessage: string;
        steering: number;
        accel: number;
        brake: number;
        gear: Gear;
        blinker: Blinker | null;
        currentPose?: {}; // FIXME:
        timestamp?: number;
        light?: unknown;
        mode?: DriveMode;
        emergency?: boolean;
    }
}

export interface Vehicle {
    readonly id: Vehicle.Id;
    readonly name: string;
    readonly cameras: CameraDevice[];
    readonly microphones: MicrophoneDevice[];
}
